import { createSlice } from "@reduxjs/toolkit";

// Helper function to get initial state from URL params
const getInitialState = () => {
  const searchParams = new URLSearchParams(window.location.search);

  return {
    processLogsList: [],
    processLogsSummeryData: [],
    argoPODLogData: [],
    selectedWorkFlow: searchParams.get("workflow_name") || [],
    selectedLogsPackage: searchParams.get("package_name")?.split(",") || [],
    selectedLogsProcessName: searchParams.get("process_id")?.split(",") || [],
    selectedLogsStatus: searchParams.get("status")?.split(",") || [],
    selectedLogsBrand: searchParams.get("brand_id")?.split(",") || [],
    selectedProcessLogsDateRange: [],
    selectedLogsInterface: searchParams.get("interface_id")?.split(",") || [],
    selectedRunMethodList: searchParams.get("run_method")?.split(",") || [],
    selectedStepList: searchParams.get("step")?.split(",") || [],
    isProcessLogsLoading: false,
    isTableLoading: false,
    selectedRow: {},
    page: parseInt(searchParams.get("page") || "0", 10),
    rowsPerPage: 10,
    sort: {
      keytoSort: "",
      direction: "",
    },
    totalProcessLogs: 0,
    logsFilterDataList: [],
    isFilterAnyLogs: false,
    processLogsFilters: [],
    bigProcessLogsFilters: [],
    filtersLoading: false, // Add this line
    selectedPackageAutoComplete: null,
    exportLoading: false,
  };
};

const initialState = getInitialState();

const monitoringProcessLogsSlice = createSlice({
  name: "monitoringProcessLogs",
  initialState,
  reducers: {
    setProcessLogsList: (state, action) => {
      state.processLogsList = action.payload;
    },
    setProcessLogsSummeryData: (state, action) => {
      state.processLogsSummeryData = action.payload;
    },
    setArgoPODLogData: (state, action) => {
      state.argoPODLogData = action.payload;
    },
    setSelectedWorkFlow: (state, action) => {
      state.selectedWorkFlow = action.payload;
    },
    setSelectedLogsPackage: (state, action) => {
      state.selectedLogsPackage = action.payload;
    },
    setSelectedLogsProcessName: (state, action) => {
      state.selectedLogsProcessName = action.payload;
    },
    setSelectedLogsStatus: (state, action) => {
      state.selectedLogsStatus = action.payload;
    },
    setSelectedLogsBrand: (state, action) => {
      state.selectedLogsBrand = action.payload;
    },
    setSelectedLogsInterface: (state, action) => {
      state.selectedLogsInterface = action.payload;
    },
    setSelectedProcessLogsDateRange: (state, action) => {
      state.selectedProcessLogsDateRange = action.payload;
    },
    setLogsFilterDataList: (state, action) => {
      state.logsFilterDataList = action.payload;
    },
    setTotalProcessLogs: (state, action) => {
      state.totalProcessLogs = action.payload;
    },
    setSort: (state, action) => {
      state.sort = action.payload;
    },
    setPage: (state, action) => {
      state.page = action.payload;
    },
    setRowsPerPage: (state, action) => {
      state.rowsPerPage = action.payload;
    },
    setIsProcessLogsLoading: (state, action) => {
      state.isProcessLogsLoading = action.payload;
    },
    setSelectedRow: (state, action) => {
      state.selectedRow = action.payload;
    },
    setIsFilterAnyLogs: (state, action) => {
      state.isFilterAnyLogs = action.payload;
    },
    setSelectedRunMethodList: (state, action) => {
      state.selectedRunMethodList = action.payload;
    },
    setSelectedStepList: (state, action) => {
      state.selectedStepList = action.payload;
    },
    setIsTableLoading: (state, action) => {
      state.isTableLoading = action.payload;
    },
    setProcessLogsFilters: (state, action) => {
      state.processLogsFilters = action.payload;
    },
    setBigProcessLogsFilters: (state, action) => {
      state.bigProcessLogsFilters = action.payload;
    },
    setFiltersLoading: (state, action) => {
      state.filtersLoading = action.payload;
    },
    setSelectedPackageAutoComplete: (state, action) => {
      state.selectedPackageAutoComplete = action.payload;
    },
    setExportLoading: (state, action) => {
      state.exportLoading = action.payload;
    },
  },
});

export const {
  setProcessLogsList,
  setProcessLogsSummeryData,
  setArgoPODLogData,
  setSelectedWorkFlow,
  setSelectedLogsPackage,
  setSelectedLogsProcessName,
  setSelectedLogsStatus,
  setSelectedLogsBrand,
  setSelectedProcessLogsDateRange,
  setSelectedLogsInterface,
  setSelectedRunMethodList,
  setSelectedStepList,
  setSort,
  setPage,
  setRowsPerPage,
  setIsProcessLogsLoading,
  setIsTableLoading,
  setSelectedRow,
  setLogsFilterDataList,
  setTotalProcessLogs,
  setIsFilterAnyLogs,
  setProcessLogsFilters,
  setBigProcessLogsFilters,
  setFiltersLoading,
  setSelectedPackageAutoComplete,
  setExportLoading,
} = monitoringProcessLogsSlice.actions;

export default monitoringProcessLogsSlice.reducer;
